import React from 'react';
import { useSelector } from 'react-redux';
import { AppWrapper, MainContainer } from './AdminLayout.styles';
import SideBar from './SideBar';

const AdminLayout = ({ children }) => {
  const sinatra = useSelector(state => state.sinatra);

  return (
    <MainContainer>
      <SideBar
        currentApp={
          sinatra.user.currentRole ? sinatra.user.currentRole.application : ''
        }
      />
      <AppWrapper>{children}</AppWrapper>
    </MainContainer>
  );
};

export default AdminLayout;
